import styled from 'styled-components';

import { getTheme } from '../../util/theme';

export const ResultsStyles = styled.section`
  border-top: 1px solid ${getTheme('grey')};
  margin-bottom: ${getTheme('doubleSpace')};
  margin-left: auto;
  margin-right: auto;
  margin-top: ${getTheme('doubleSpace')};
  max-width: 60rem;
  padding-top: ${getTheme('doubleSpace')};

  .ReactTable {
    border: none;

    .rt-thead .rt-th,
    .rt-tbody .rt-td {
      border: none;
    }

    .rt-thead {
      background-color: ${getTheme('lightBlue')};
      padding-bottom: ${getTheme('halfSpace')};
      padding-top: ${getTheme('halfSpace')};

      &.-header {
        box-shadow: none;
      }
    }

    .rt-resizable-header-content {
      font-size: 0.75rem;
      font-weight: 700;
    }

    .rt-tr-group {
      padding-bottom: ${getTheme('halfSpace')};
      padding-top: ${getTheme('halfSpace')};
    }

    .rt-td {
      font-size: 0.875rem;

      &:nth-child(4) {
        width: 7.5% !important;
      }

      &:last-child {
        text-align: right;
        width: 7.5% !important;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/ResultTable/styled-components.js